<!-- ═══════════════ OVERLAY ═══════════════ -->
<div class="filter-overlay" *ngIf="open"></div>

<!-- ═══════════════ FLOATING FILTER PANEL ═══════════════ -->
<div class="filter-panel" [class.open]="open" [style.width]="panelWidth || null">

  <!-- Panel Body — projected content goes here -->
  <div class="filter-panel-body">
    <ng-content></ng-content>
  </div>

  <!-- Panel Footer -->
  <div class="filter-panel-footer">
    <button *ngIf="showClose" class="filter-btn-dark" type="button" (click)="onClose()">Close</button>
    <button *ngIf="showClearAll" class="filter-btn-dark" type="button" (click)="onClearAll()">Clear All</button>
    <button class="custom-orange-button" type="button" (click)="onSearch()">{{ searchLabel }}</button>
  </div>

</div>
